// eslint-disable-next-line no-shadow
export enum HeadingType {
  H1 = 'h1',
}
